import React, { useState, useCallback, useRef, useEffect } from 'react';
import { View, Text, TouchableOpacity, Image, ActivityIndicator } from 'react-native';
//import Carousel, { Pagination } from 'react-native-snap-carousel';
import { FontAwesome } from "@expo/vector-icons";
import { LinearGradient } from 'expo-linear-gradient';
import { useIsFocused } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';

import HeaderDefault from '../../components/HeaderDefault';
import { toast } from '../../utils/toast';
import api from '../../services/api';

import styles from './styles';

const MyCards = ({ navigation }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const ref = useRef(null);
    const [cards, setCards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const isFocused = useIsFocused();

    useEffect(() => {
        getDataCards();
    }, [isFocused]);

    async function getDataCards() {
        setIsLoading(true);
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        api.get('/cards', { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                var cards = [];

                res.data.data.map(item => {
                    cards.push({
                        name: item.name,
                        number: item.card_number,
                        validity: item.expiration_date,
                        id: item.id
                    })
                })

                setCards(cards);
                setIsLoading(false);
            })
            .catch(() => {
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }

    const renderItem = useCallback(({ item, index }) => {
        return (
            <LinearGradient
                start={{ x: -1, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={["#16195B", "#1FBFB5"]}
                style={styles.contentCard}
            >
                <TouchableOpacity style={styles.contentEdit} onPress={() => navigation.navigate('EditCard', { item })}>
                    <FontAwesome name="edit" size={24} color="#000" />
                </TouchableOpacity>

                <Image source={require('../../../assets/icon_coin.png')} style={styles.img_coin} />

                <Text style={styles.textDescription}>{item.number}</Text>
                <Text style={styles.textDescription}>{item.name}</Text>
                <Text style={styles.textDescription}>{item.validity}</Text>

                <Image source={require('../../../assets/masterCard.png')} style={styles.imgBank} />
            </LinearGradient>
        );
    }, []);

    return (
        <>
            <HeaderDefault title={'Meus cartões'} />

            {
                isLoading ? (
                    <ActivityIndicator color="#1FBFB5" size="large" style={{ marginTop: 10 }} />
                ) : (
                    <>
                        {
                            cards.length === 0 ? (
                                <Text style={styles.textNotFoundAccounts}>Nenhum cartão foi encontrado.</Text>
                            ) : (
                                <View>
                                 <Text>   Implementar carrossel </Text>
                                    {/* <Carousel
                                        layout={"default"}
                                        ref={ref}
                                        data={cards}
                                        sliderWidth={400}
                                        itemWidth={350}
                                        renderItem={renderItem}
                                        onSnapToItem={index => setActiveIndex(index)}
                                    /> */}
                                 
                                </View>
                            )
                        }

                        <View style={styles.container}>
                            <TouchableOpacity style={styles.btnAdd} onPress={() => navigation.navigate('NewCard')}>
                                <Text style={styles.textBtn}>CADASTRAR NOVO CARTÃO</Text>
                            </TouchableOpacity>
                        </View>
                    </>
                )
            }

        </>
    );
}

export default MyCards;